import React, {useState, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {CardsWidget7} from '../../../../../_metronic/partials/widgets'
import {
  RoutesMetaForDoctors,
} from '../../modules/accounts/components/CRUDWrapper/routesMeta'
import {useReduxAuth} from '../../../auth'
import TimeTrackedChart from './TimeTrackedChart'
import DashboardClosedSidebar from '../../components/doctor-dashboard/DashboardClosedSidebar'

const DashboardPage = ({
  routeMeta,
  data,
  pieData,
  COLORS,
  totalPatients,
  totalNurses,
  countDoctorDevices,
}) => {
  const {currentUser} = useReduxAuth()
  return (
    <>
      {currentUser?.userRole === 'doctor' ? (
        <>
          <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
            {/* Begin::Grid Layout */}
            <div className='col-md-8'>
              {/* First Row */}
              <div className='row'>
                <div className='col-md-4'>
                  <CardsWidget7
                    className='h-md-100'
                    description='Total Staff'
                    icon={false}
                    stats={5}
                    labelColor='dark'
                    textColor='gray-300'
                  />
                </div>
                <div className='col-md-4'>
                  <CardsWidget7
                    className='h-md-100'
                    description='Total Patients'
                    icon={false}
                    stats={6}
                    labelColor='dark'
                    textColor='gray-300'
                  />
                </div>
                <div className='col-md-4'>
                  <CardsWidget7
                    className='h-md-100'
                    description='Active Patients'
                    icon={false}
                    stats={6}
                    labelColor='dark'
                    textColor='gray-300'
                  />
                </div>
              </div>

              {/* Second Row */}
              <div className='row mt-4'>
                <div className='col-md-4'>
                  <CardsWidget7
                    className='h-md-100'
                    description='Total Devices'
                    icon={false}
                    stats={10}
                    labelColor='dark'
                    textColor='gray-300'
                  />
                </div>
                <div className='col-md-4'>
                  <CardsWidget7
                    className='h-md-100'
                    description='Active Devices'
                    icon
                    stats={3}
                    labelColor='dark'
                    textColor='gray-300'
                  />
                </div>
                <div className='col-md-4'>
                  <CardsWidget7
                    className='h-md-100'
                    description='Emergency Alert'
                    icon
                    stats={1}
                    labelColor='dark'
                    textColor='gray-300'
                  />
                </div>
              </div>
            </div>

            {/* 7th Card (Spanning Two Rows) */}
            <div className='col-md-4 d-flex align-items-stretch'>
              <div
                className='card h-100 w-100 shadow-sm p-4 rounded-lg justify-content-center'
                style={{backgroundColor: '#f8f9fa', borderRadius: '15px'}}
              >
                <h5 className='mb-3 text-dark fw-bold'>Core Complaints</h5>
                <ul className='list-unstyled'>
                  <li
                    className='d-flex align-items-center mb-3 p-2 rounded'
                    style={{backgroundColor: '#e9fbe5'}}
                  >
                    <span
                      className='badge bg-success me-3'
                      style={{width: '12px', height: '12px', borderRadius: '50%'}}
                    ></span>
                    <span className='text-dark fw-medium'>High Blood Pressure</span>
                  </li>
                  <li
                    className='d-flex align-items-center mb-3 p-2 rounded'
                    style={{backgroundColor: '#fff3cd'}}
                  >
                    <span
                      className='badge bg-warning me-3'
                      style={{width: '12px', height: '12px', borderRadius: '50%'}}
                    ></span>
                    <span className='text-dark fw-medium'>Severe Pain</span>
                  </li>
                  <li
                    className='d-flex align-items-center mb-3 p-2 rounded'
                    style={{backgroundColor: '#f8d7da'}}
                  >
                    <span
                      className='badge bg-danger me-3'
                      style={{width: '12px', height: '12px', borderRadius: '50%'}}
                    ></span>
                    <span className='text-dark fw-medium'>Smoking</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* time track chart */}
          <div className='mt-20'>
            <TimeTrackedChart />
          </div>
        </>
      ) : (
        <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
          {/* Begin::Grid Layout */}
          <div className='col-md-4'>
            <CardsWidget7
              className='h-md-100'
              description='Total Staff'
              icon={false}
              stats={5}
              labelColor='dark'
              textColor='gray-300'
            />
          </div>
          <div className='col-md-4'>
            <CardsWidget7
              className='h-md-100'
              description='Total Patients'
              icon={false}
              stats={6}
              labelColor='dark'
              textColor='gray-300'
            />
          </div>
          <div className='col-md-4'>
            <CardsWidget7
              className='h-md-100'
              description='Total Devices'
              icon={false}
              stats={6}
              labelColor='dark'
              textColor='gray-300'
            />
          </div>
        </div>
      )}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  const {currentUser} = useReduxAuth()
  const routeMeta = RoutesMetaForDoctors['overView']
  const [totalNurses, setTotalNurses] = useState(0)
  const [totalPatients, setTotalPatients] = useState(0)
  const [countDevices, setCountDevices] = useState(0)

  const [criticalPatients, setCriticalPatients] = useState(0)
  const [data, setData] = useState([])
  const totalRecords = 100
  const abnormalRecords = 10
  const normalRecords = totalRecords - abnormalRecords

  const pieData = [
    {name: 'Normal', value: normalRecords},
    {name: 'Critical', value: abnormalRecords},
  ]

  const COLORS = ['#413ea0', '#FF0000']
  const fetchData = async () => {
    try {
      if (currentUser) {
console.log("")
      } else {
      }
    } catch (error) {}
  }
  // Fetch data only on the first render

  useEffect(() => {
    fetchData()
  }, [routeMeta.fetchLatestDataPath, currentUser]) // Add currentUser to dependencies to ensure re-render if it updates

  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      {/* <DashboardPage
        routeMeta={routeMeta}
        data={data}
        pieData={pieData}
        COLORS={COLORS}
        totalNurses={totalNurses}
        totalPatients={totalPatients}
        countDoctorDevices={countDevices}
      /> */}
      <DashboardClosedSidebar />
    </>
  )
}

export {DashboardWrapper}
